export const APP_TIME_ZONE = 'America/Bogota';

const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

function getFormatter(locale, options) {
  return new Intl.DateTimeFormat(locale, {
    timeZone: APP_TIME_ZONE,
    ...options
  });
}

function getFormatterParts(date) {
  return getFormatter('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).formatToParts(date);
}

function getSafeDate(value) {
  if (!value) return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const raw = String(value).trim();
  if (!raw) return null;

  const dateOnlyMatch = raw.match(DATE_ONLY_PATTERN);
  if (dateOnlyMatch) {
    const [, year, month, day] = dateOnlyMatch;
    return new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), 12, 0, 0));
  }

  const parsed = new Date(raw);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

function getIsoDateFromDate(date) {
  const parts = getFormatterParts(date).reduce((accumulator, part) => {
    if (part.type !== 'literal') {
      accumulator[part.type] = part.value;
    }
    return accumulator;
  }, {});

  return `${parts.year}-${parts.month}-${parts.day}`;
}

export function formatDateInBogota(value, locale = 'es-CO') {
  const date = getSafeDate(value);
  if (!date) return '';

  return getFormatter(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).format(date);
}

export function formatDateTimeInBogota(value, locale = 'es-CO') {
  const date = getSafeDate(value);
  if (!date) return '';

  return getFormatter(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  }).format(date);
}

export function formatIsoDateInBogota(value) {
  const date = getSafeDate(value);
  if (!date) return '';

  return getIsoDateFromDate(date);
}

export function getCurrentIsoDateInBogota() {
  return getIsoDateFromDate(new Date());
}
